import { ReferencedEntry } from 'contentful';
import { useEffect, useState } from 'react';

import { ContentType, Feature, Subject, SubscriptionPlan } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ArrayFilters, Filter } from 'src/api/contentful/fetchEntries';
import { useContentfulEntries } from 'src/components/UseContentfulEntries/UseContentfulEntries';
import { getField, getSys } from 'src/utils/EntryUtil';

export function useFeatureMap(items: ReadonlyArray<ReferencedEntry<SubscriptionPlan>>) {
  const [ featureMap, setFeatureMap ] = useState({});

  // Get all features that reference one of items passed in
  const { entries } = useContentfulEntries<Feature>(() => ({
    contentType: ContentType.FEATURE,
    filters: {
      fields: {
        product: {
          sys: {
            id: new Filter(
              ArrayFilters.INCLUDES_ONE_OF,
              items.map(item => getSys(item, 'id') || '')
            ),
          },
        },
      },
    },
  }), []);

  useEffect(() => {
    if (!entries || entries.length === 0) { return; }

    const productFeatureMap = entries.reduce((acc, feature) => {
      const featureTopicId = getSys(getField(feature, 'featureTopic'), 'id');
      const productId = getSys(getField(feature, 'product'), 'id');
      if (featureTopicId && productId) {
        if (!acc[productId]) {
          acc[productId] = {};
        }
        acc[productId][featureTopicId] = feature;
      }
      return acc;
    }, {});
    setFeatureMap(productFeatureMap);
  }, [ entries ]);

  const getFeatureForComparisonItem = (feature: ReferencedEntry<Subject>, item: ReferencedEntry<SubscriptionPlan>) => {
    const productFeatures = featureMap[getSys(item, 'id') || ''] || {};
    return productFeatures[getSys(feature, 'id') || ''] as ReferencedEntry<Feature>;
  };

  return { getFeatureForComparisonItem };
}
